import React, { useState, useEffect } from 'react';
import BlackButton from '../Utils/BlackButton';
import GrayButton from '../Utils/GrayButton';

//const IP = "http://143.110.239.79:5010/"
const IP = "https://pepetoys-backend.mindnt.com.mx/api/"
//const IP = "http://localhost:5010/"

const ModalAddProduct = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    description: '',
    atributo_1: '',
    atributo_2: '',
    product_counter_init: '',
    product_counter: ''
  });

  const [imageUrls, setImageUrls] = useState([]);
  const [newImageUrl, setNewImageUrl] = useState('');

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  // Fetch categories when modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedCategoryIds([]);
      setImageUrls([]);
      setNewImageUrl('');
      fetchCategories();
    }
  }, [isOpen]);

  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      const response = await fetch(`${IP}items/categories`);
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          setAllCategories(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoadingCategories(false);
    }
  };

  const toggleCategory = (catId) => {
    const id = parseInt(catId, 10);
    setSelectedCategoryIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
    if (errors.categories) setErrors(prev => ({ ...prev, categories: '' }));
  };

  const addImageUrl = () => {
    const url = newImageUrl.trim();
    if (!url) return;
    if (imageUrls.includes(url)) {
      setErrors(prev => ({ ...prev, duplicateImage: 'Esta imagen ya fue agregada' }));
      return;
    }
    setImageUrls(prev => [...prev, url]);
    setNewImageUrl('');
    setErrors(prev => ({ ...prev, duplicateImage: '' }));
  };

  const removeImageUrl = (index) => {
    setImageUrls(prev => prev.filter((_, i) => i !== index));
  };

  const handleImageUrlKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addImageUrl();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'El nombre es requerido';
    if (!formData.price || formData.price <= 0) newErrors.price = 'El precio debe ser mayor a 0';
    if (selectedCategoryIds.length === 0) newErrors.categories = 'Selecciona al menos una categoría';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      const primaryImage = imageUrls.length > 0 ? imageUrls[0] : 'https';
      const params = new URLSearchParams({
        name: formData.name,
        description: formData.description || '',
        category_ids: JSON.stringify(selectedCategoryIds),
        price: formData.price,
        img_base64: primaryImage,
        product_counter_init: formData.product_counter_init || '0',
        product_counter: formData.product_counter || '0',
        atributo_1: formData.atributo_1 || '',
        atributo_2: formData.atributo_2 || ''
      });

      if (imageUrls.length > 0) {
        params.append('images', JSON.stringify(imageUrls));
      }

      const response = await fetch(`${IP}items/insert-item?${params}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const result = await response.json();
        onSave(result);

        // Reset form
        setFormData({
          name: '',
          price: '',
          description: '',
          atributo_1: '',
          atributo_2: '',
          product_counter_init: '',
          product_counter: ''
        });
        setSelectedCategoryIds([]);
        setImageUrls([]);
        setNewImageUrl('');
        setErrors({});
        onClose();
      } else {
        throw new Error('Error al guardar el producto');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrors({ submit: 'Error al guardar el producto. Intenta nuevamente.' });
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-900">Agregar Producto</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nombre *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 ${errors.name ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="Nombre del producto"
                disabled={isLoading}
              />
              {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Precio *
              </label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                step="0.01"
                min="0"
                className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 ${errors.price ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="0.00"
                disabled={isLoading}
              />
              {errors.price && <p className="text-red-500 text-xs mt-1">{errors.price}</p>}
            </div>

            {/* Selector de categorías tipo pills */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Categorías *
                <span className="ml-1 text-gray-400 font-normal text-xs">
                  ({selectedCategoryIds.length} seleccionada{selectedCategoryIds.length !== 1 ? 's' : ''})
                </span>
              </label>
              {loadingCategories ? (
                <p className="text-sm text-gray-500">Cargando categorías...</p>
              ) : allCategories.length === 0 ? (
                <p className="text-sm text-gray-400">No hay categorías disponibles</p>
              ) : (
                <div className="flex flex-wrap gap-2">
                  {allCategories.map(cat => {
                    const isSelected = selectedCategoryIds.includes(parseInt(cat.id, 10));
                    return (
                      <button
                        key={cat.id}
                        type="button"
                        onClick={() => toggleCategory(cat.id)}
                        disabled={isLoading}
                        className={`
                          px-3 py-1.5 rounded-full text-sm font-medium border transition-all duration-150 cursor-pointer select-none
                          ${isSelected
                            ? 'bg-gray-900 text-white border-gray-900 shadow-sm'
                            : 'bg-white text-gray-600 border-gray-300 hover:border-gray-500 hover:text-gray-800'
                          }
                        `}
                      >
                        {isSelected && <span className="mr-1">✓</span>}
                        {cat.name}
                      </button>
                    );
                  })}
                </div>
              )}
              {errors.categories && <p className="text-red-500 text-xs mt-1">{errors.categories}</p>}
            </div>

            {/* Selector de imágenes múltiples */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Imágenes
                {imageUrls.length > 0 && (
                  <span className="ml-1 text-gray-400 font-normal text-xs">
                    ({imageUrls.length} imagen{imageUrls.length !== 1 ? 'es' : ''})
                  </span>
                )}
              </label>
              <div className="flex gap-2">
                <input
                  type="url"
                  value={newImageUrl}
                  onChange={(e) => setNewImageUrl(e.target.value)}
                  onKeyDown={handleImageUrlKeyDown}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  placeholder="https://ejemplo.com/imagen.jpg"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={addImageUrl}
                  disabled={isLoading || !newImageUrl.trim()}
                  className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
                >
                  +
                </button>
              </div>
              {errors.duplicateImage && <p className="text-red-500 text-xs mt-1">{errors.duplicateImage}</p>}

              {imageUrls.length > 0 && (
                <div className="mt-3 space-y-2">
                  {imageUrls.map((url, index) => (
                    <div key={index} className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2">
                      <span className="text-xs text-gray-400 font-mono w-5">{index + 1}</span>
                      {index === 0 && (
                        <span className="text-[10px] bg-gray-900 text-white px-1.5 py-0.5 rounded font-medium">Principal</span>
                      )}
                      <img
                        src={url}
                        alt={`img ${index + 1}`}
                        className="w-10 h-10 object-cover rounded"
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                      <span className="flex-1 text-sm text-gray-600 truncate">{url}</span>
                      <button
                        type="button"
                        onClick={() => removeImageUrl(index)}
                        disabled={isLoading}
                        className="text-red-400 hover:text-red-600 text-sm font-bold px-1"
                      >
                        x
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Descripción
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                placeholder="Descripción del producto"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Atributo 1
              </label>
              <input
                type="text"
                name="atributo_1"
                value={formData.atributo_1}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                placeholder="Valor del atributo 1"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Atributo 2
              </label>
              <input
                type="text"
                name="atributo_2"
                value={formData.atributo_2}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                placeholder="Valor del atributo 2"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contador Inicial
              </label>
              <input
                type="number"
                name="product_counter_init"
                value={formData.product_counter_init}
                onChange={handleChange}
                min="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                placeholder="Valor inicial del contador"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contador Actual
              </label>
              <input
                type="number"
                name="product_counter"
                value={formData.product_counter}
                onChange={handleChange}
                min="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                placeholder="Valor actual del contador"
                disabled={isLoading}
              />
            </div>

            {errors.submit && (
              <div className="text-red-500 text-sm text-center">
                {errors.submit}
              </div>
            )}

            <div className="flex space-x-3 pt-4">
              <GrayButton onClick={onClose} className="flex-1" disabled={isLoading}>
                Cancelar
              </GrayButton>
              <BlackButton type="submit" className="flex-1" disabled={isLoading}>
                {isLoading ? 'Guardando...' : 'Guardar'}
              </BlackButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalAddProduct;